import { Injectable } from '@angular/core';
import {SignUpTo} from "../classes/sign-up-to";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SignUpService {

  signUpTO: SignUpTo;

  constructor(private http: HttpClient) {}

  public submitSignUp(signUpTO: SignUpTo): Observable<Object> {
    return this.http.post('/rest/account/signup', signUpTO);
  }

  public resendActivationCode(signUpTO: SignUpTo): Observable<Object> {
    return this.http.post('/rest/account/resend', signUpTO);
  }

  public verifySignUp(signUpTO: SignUpTo): Observable<Object> {
    return this.http.post('/rest/account/verify', signUpTO);
  }
}
